import React, { Component, createRef } from 'react';

import HighchartsReact from "highcharts-react-official";
import Highcharts from "highcharts";
import more from "highcharts/highcharts-more";
import draggable from "highcharts/modules/draggable-points";
import {Context} from "context";

// import vars from "styles/vars.scss";
import vars_dark from "styles/_vars-dark.scss";
import vars_light from "styles/_vars-light.scss";


if (typeof Highcharts === "object") {
    more(Highcharts);
    draggable(Highcharts);
}

class TwoD extends Component {
    static contextType = Context;

    chart = createRef();

    state = {
        saving: false
    };

    // todo - Comment needed for this function
    highChartsStyleConstructor = () => {
        const table = this.props.table;
        const xAxisLabel = table.dimension === 2 ? table.xAxis.formattedName : "";

        return {
            chart: {
                backgroundColor: "none",
                height: this.props.height,
            },
            plotOptions: {
                line: {
                    color: this.context.lightTheme ? vars_light.txtSecondary : 'white',
                    lineWidth: "1"
                },
                series: {
                    allowPointSelect: true,
                    marker: {
                        enabled: true,
                        states: {
                            fillColor: this.context.lightTheme ? vars_light.txtSecondary : 'white',
                            hover: {
                                enabled: false
                            },
                            select: {
                                fillColor: this.context.lightTheme ? vars_light.highlightTertiary : 'white',
                                radius: 6,
                                lineWidth: 0
                            }
                        }
                    },
                    animation: false,
                    states: {
                        hover: {
                            enabled: false
                        }
                    },
                }
            },
            xAxis: {
                title: {
                    text: xAxisLabel,
                    style: {
                        fontSize: "4px",
                        lineHeight: "15px"
                    }
                },
                gridLineColor: this.context.lightTheme ? vars_light.highlightTertiary : vars_dark.highlightTertiary,
                lineColor: this.context.lightTheme ? vars_light.highlightTertiary : vars_dark.highlightTertiary,
                tickColor: this.context.lightTheme ? vars_light.highlightTertiary : vars_dark.highlightTertiary,
                labels: {
                    enabled: true
                }
            },
            yAxis: {
                title: {
                    text: table.dataAxis.formattedName,
                    style: {
                        fontSize: "4px",
                        lineHeight: "15px"
                    }
                },
                gridLineColor: this.context.lightTheme ? vars_light.txtSecondary : vars_dark.highlightTertiary,
                labels: {
                    enabled: true
                }
            }
        }
    };

    // todo - Comment needed for this function
    highChartsDataConstructor = () => {
        const table = this.props.table;
        let data;
        let uploaded = this.props.uploaded;

        //map data to format highcharts expects - x,y pairs
        if (table.dimension === 2) {
            data = table.dataAxis.matrix.values.reduce((acc, val) => acc.concat(val), []).map((e, i) => [table.xAxis.matrix.values.reduce((acc, val) => acc.concat(val), [])[i], e]);
            uploaded = uploaded.dataAxis.matrix.values.reduce((acc, val) => acc.concat(val), []).map((e, i) => [this.props.uploaded.xAxis.matrix.values.reduce((acc, val) => acc.concat(val), [])[i], e]);
        } else {
            data = table.dataAxis.matrix.values.reduce((acc, val) => acc.concat(val), []);
            uploaded = uploaded.dataAxis.matrix.values.reduce((acc, val) => acc.concat(val), []);
        }

        return {
            legend: {
                enabled: false
            },
            tooltip: {
                enabled: false
            },
            title: {
                text: ""
            },
            credits: {
                enabled: false
            },
            series: [{
                states: {
                    hover: false
                },
                dragDrop: {
                    draggableY: true,
                },
                data: data,
                lineWidth: 2,
                zIndex: 2,
                point: {
                    events: {
                        drag: (event) => {
                            if(!this.state.saving) {
                                let newPoint = event.newPointId;
                                newPoint = {
                                    x: event.newPoints[newPoint].point.index,
                                    y: event.newPoint.y
                                };

                                this.props.updateValue(newPoint);
                            } else {
                                event.preventDefault();
                            }
                        },
                        drop: () => {
                            if(!this.state.saving) {
                                this.setState({
                                    saving: true
                                }, () => {
                                    this.props.save().then(() => {
                                        this.setState({
                                            saving: false
                                        })
                                    });
                                })
                            }
                        }
                    }
                },
            }, {
                dragDrop: {
                    draggableY: false,
                },
                type: "line",
                data: uploaded,
                lineWidth: 2,
                zIndex: 1,
                color: this.context.lightTheme ? '#999' : vars_dark.txtSecondary,
                marker: {
                    symbol: "circle",
                    states: {
                        hover: {
                            enabled: false
                        }
                    }
                },
                states: {
                    hover: {
                        enabled: false
                    }
                },
                selected: false,
                enableMouseTracking: false
            }]
        }
    };

    componentDidUpdate(prevProps, prevState, snapshot) {
        // if (this.props.selection){
        //     const start = this.props.selection.topLeft.j;
        //     const stop = this.props.selection.bottomRight.j;
        //
        //     this.chart.current.getChart().series[0].data.forEach((point, index) => {
        //         point.select(index >= start && index <= stop, true)
        //     });
        // }
    }

    render() {
        return (
            <div className={`twoD ${this.state.saving ? "saving" : null}`}>
                {this.state.saving && <p>Saving...</p>}
                <HighchartsReact
                    ref={this.chart}
                    highcharts={Highcharts}
                    options = {{
                        ...this.highChartsDataConstructor(),
                        ...this.highChartsStyleConstructor()
                    }}
                />
            </div>
        )        
    }
}

export default TwoD;
